import PageLoader from "../../../common/controls/pageloader";
import participantsView from "../participants";
import eventsService from "../../../../services/eventsService";
import appointmentService from "../../../../services//appointmentService";
import moment from "moment";
import config from "../../../../../secrets/config";
import pageheader from "../../../pageheader";
import utils from "../../../../utils/util";
import { mapGetters } from "vuex";

export default {
  name: "appointmentslist",
  components: { PageLoader, participantsView, pageheader },
  props: [],
  data() {
    return {
      input: {},
      eventId: this.$route.params.eventId,
      eventTitle: "",
      eventDescription: "",
      showloadingSection: false,
      showParticipantsModal: false,
      counterKey: 0,
      search: "",
      syncevent1: config.syncevent.eventId,
      syncevent2: config.syncevent.eventIdPl,
      participantsList: [],
      sortBy: "startDateTime",
      sortDesc: true,
      headers: [
        {
          text: "Organizer",
          align: "left",
          sortable: true,
          value: "organizer.name"
        },
        {
          text: "Organizer Email",
          sortable: true,
          value: "organizer.email"
        },
        {
          text: "Participant Count",
          sortable: true,
          value: "participants.length"
        },
        {
          text: "Is Cancelled",
          sortable: true,
          value: "participants.isCancelled"
        },
        {
          text: "Reference ID",
          sortable: true,
          value: "referenceId"
        },

        {
          text: "Start",
          sortable: true,
          value: "startDateTime"
        },
        {
          text: "End",
          sortable: true,
          value: "endDateTime"
        },
        {
          text: "Sync",
          sortable: false,
          value: "isSync"
        },
        {
          text: "Action",
          sortable: false,
          value: "actions"
        }
      ],
      appointmentsList: [],
      pagination: {
        // sortBy: "startDateTime",
        // rowsPerPage: 5,
        // descending: true
      },
      page: 1,
      isSyncing: false,
      syncingItemID: null,
      syncingReferenceID: null,
      deleteAppointmentDialog: false,
      isDeleting: false,
      deleteEvent: {},
      deleteEventPartipants: "",
      openedPanel: [],
      isExpanded: false,
      showbanner:true
    };
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatDate: function(value) {
      if (value != "" && value != null && value != undefined) {
        return moment(String(value)).format("MM/DD/YYYY HH:mm");
      } else {
        return "";
      }
    },
    formatMonth: function(value) {
      if (value != "" && value != null && value != undefined) {
        return moment(String(value), "MM").format("MMM");
      } else {
        return "";
      }
    },
    formatAmount(value) {
      if (value != "" && value != null && value != undefined) {
        value = Math.round(value * 100) / 100;
        return (
          "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        );
      } else {
        return "$0";
      }
    },
    lowercase: function(value) {
      if (value) {
        return value.toLowerCase();
      }
    },
  },
  computed: {
    ...mapGetters(["roles"]),
    pages() {
      var datatable = this.$refs.table;
      if (datatable && typeof datatable != "undefined") {
        return this.pagination.rowsPerPage
          ? Math.ceil(datatable.itemsLength / this.pagination.rowsPerPage)
          : 0;
      }

      return this.pagination.rowsPerPage
        ? Math.ceil(this.appointmentsList.length / this.pagination.rowsPerPage)
        : 0;
    },
    _headers() {
      if (this.eventId != this.syncevent1 && this.eventId != this.syncevent2) {
        return this.headers.filter(header => header.text !== "Sync");
      }
      return this.headers;
    }
  },
  created() {},
  mounted() {
    this.input = utils.getInputContent("appointments", this.roles);
    this.showloadingSection = true;
    this.getAppointments();
    //this.geteventDetails();
  },
  methods: {
    backToEvents() {
      this.$router.push("/events/all");
    },
    geteventDetails() {
      eventsService.getEventfromID(
        this,
        data => {
          if (data) {
            this.eventTitle = data.title;
            this.eventDescription = data.description;
            this.showloadingSection = false;
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    getAppointments() {
      appointmentService.getAppointmentsForEvent(
        this,
        data => {
          if (data) {
            //this.appointmentsList = data.appointments;
            this.appointmentsList = [];
            data.appointments.map(item => {
              if (item.isCancelled) {
                item.isSync = false;
              } else {
                item.isSync = true;
              }
              this.appointmentsList.push(item);
            });
          }
          this.geteventDetails();
          //this.showloadingSection = false;
        },
        error => {
          console.log(error);
          this.showloadingSection = false;
        }
      );
    },
    viewParticipantsClick(participants) {
      this.forceRerender();
      this.participantsList = participants;
      this.showParticipantsModal = true;
    },
    forceRerender() {
      this.counterKey += 1;
    },
    syncClick(item) {
      this.isSyncing = true;
      this.syncingItemID = item.id;
      this.syncingReferenceID = item.referenceId;

      // this.syncingItemID = "01a640a0-0bb8-4fbd-8d2d-940bbb28f5df";
      // this.syncingReferenceID = "B-20-015785";
      eventsService.syncAppointment(
        this,
        response => {
          if (response.isSuccess) {
            this.$toast.success(response.systemMessage);
          } else {
            this.$toast.error(response.systemMessage);
          }
          this.isSyncing = false;
        },
        error => {
          this.isSyncing = false;
          console.log(error);
        }
      );
    },
    cancelEventClick(item) {
      this.deleteEvent = item;
      this.deleteEventPartipants = "";
      item.participants.map((particpantItem, index) => {
        if (
          particpantItem.firstName &&
          particpantItem.lastName &&
          index == item.participants.length - 1
        ) {
          this.deleteEventPartipants =
            this.deleteEventPartipants +
            particpantItem.firstName +
            " " +
            particpantItem.lastName;
        } else if (
          particpantItem.firstName &&
          particpantItem.lastName &&
          index != item.participants.length - 1
        ) {
          this.deleteEventPartipants =
            this.deleteEventPartipants +
            particpantItem.firstName +
            " " +
            particpantItem.lastName +
            ", ";
        }
      });
      this.deleteAppointmentDialog = true;
    },
    DeleteItemClick() {
      this.isDeleting = true;
      eventsService.deleteEvent(
        this,
        response => {
          if (response.isSuccess) {
            if (response.type.toLowerCase() == "success") {
              this.$toast.success(response.systemMessage);
              //reload events
              this.getAppointments();
            } else if (response.type.toLowerCase() == "warning") {
              this.$toast.warning(response.systemMessage);
              //reload events
              this.getAppointments();
            } else if (response.type.toLowerCase() == "error") {
              this.$toast.error(response.systemMessage);
            }

            //close modal
            this.deleteAppointmentDialog = false;
          } else {
            this.$toast.error(response.systemMessage);
          }
          this.isDeleting = false;
        },
        error => {
          this.isDeleting = false;
          console.log(error);
        }
      );
    },
    handleToggle() {
      if (this.isExpanded) {
        this.openedPanel = [0];
        this.showbanner = false;
      } else {
        this.openedPanel = [1];
        this.showbanner = true;
      }
    },
    toggleClick() {
      this.isExpanded = !this.isExpanded;
      this.handleToggle();
    },
    openModal() {
      this.$refs.modal.showModal();
    },
  }
};
